import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";
import { img, inr } from "@/lib/api";

export function ProductCard({ p, i = 0 }) {
  const { add } = useCart();
  const onSale = p.sale_price && p.in_stock;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: i * 0.06 }}
      className="group"
      data-testid="saree-card"
    >
      <Link to={`/saree/${p.id}`} className="block relative overflow-hidden rounded-sm bg-[#14110E]" data-testid={`saree-card-link-${p.id}`}>
        <img src={img(p.image_url)} alt={p.name} className={`aspect-[3/4] w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105 ${p.in_stock ? "" : "grayscale opacity-60"}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0907] via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {!p.in_stock && <Badge cls="bg-[#0B0907]/80 text-[#A89F91] border-[#A89F91]/40">Out of stock</Badge>}
          {onSale && <Badge cls="bg-[#8B1E1E] text-white border-[#8B1E1E]">Sale</Badge>}
          {p.is_new && p.in_stock && <Badge cls="bg-[#D4AF37]/15 text-[#F3E5AB] border-[#D4AF37]/50">New</Badge>}
        </div>
      </Link>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-display text-sm tracking-wide truncate">{p.name}</p>
          <p className="font-serif-it text-[#A89F91]">{p.origin || "Heritage apparel"}</p>
        </div>
        <div className="text-right shrink-0">
          {onSale ? (
            <>
              <p className="text-[#F3E5AB] text-sm" data-testid="saree-card-price">{inr(p.sale_price)}</p>
              <p className="text-xs text-[#6E6558] line-through">{inr(p.price)}</p>
            </>
          ) : (
            <p className="text-[#F3E5AB] text-sm" data-testid="saree-card-price">{inr(p.price)}</p>
          )}
        </div>
      </div>
      {p.in_stock && (
        <button onClick={() => add(p)} className="mt-3 w-full rounded-full border border-[#D4AF37]/30 py-2 text-xs uppercase tracking-[0.2em] text-[#F3E5AB] hover:bg-[#D4AF37] hover:text-[#0B0907] btn-glow" data-testid={`quick-add-${p.id}`}>
          Add to cart
        </button>
      )}
    </motion.div>
  );
}

function Badge({ cls, children }) {
  return <span className={`text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full border ${cls}`}>{children}</span>;
}
